import { useEffect, useState } from 'react'
import i18n from 'i18next'
import pt from '../../locales/pt-PT.json'
import en from '../../locales/en-GB.json'
import es from '../../locales/es-ES.json'

const resources = {
  pt,
  en,
  es,
  'pt-PT': pt,
  'en-GB': en,
  'es-ES': es,
}

i18n.init({
  resources,
  lng: 'pt-PT',
  fallbackLng: 'en-GB',
  supportedLngs: Object.keys(resources),
  interpolation: {
    // React already escapes output, so this prevents strings like 20&#x2F;05&#x2F;2026.
    escapeValue: false,
  },
})

export function getCurrentLanguage(): string {
  return i18n.resolvedLanguage || i18n.language;
}

export function changeLanguage(language: string) {
  return i18n.changeLanguage(language);
}

export function onLanguageChanged(callback: (language: string) => void) {
  i18n.on('languageChanged', callback);
  return () => i18n.off('languageChanged', callback);
}

export function useI18nLanguage() {
  const [language, setLanguage] = useState(getCurrentLanguage());

  useEffect(() => {
    return onLanguageChanged((nextLanguage) => {
      setLanguage(nextLanguage);
    });
  }, []);

  return language;
}

export function commonTranslation(key: string, options?: Record<string, any>) {
  return translate('common', key, options);
}

export function useNamespacedTranslate(namespace: string) {
  // Subscribing here ensures components re-render when language changes.
  useI18nLanguage();

  return (key: string, options?: Record<string, any>) => {
    return translate(namespace, key, options);
  };
}

export function translate(namespace: string, key: string, options?: Record<string, any>) {
  return i18n.t(`${namespace}.${key}`, options);
}